"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../../gen-src/Localize");
var TagHelpers_1 = require("../../Tag/TagHelpers");
var RootReducer_1 = require("../../app/RootReducer");
var PredictiveModelSlice_1 = require("../../store/slice/PredictiveModelSlice");
var PredictiveModelThunk_1 = require("../../store/thunk/PredictiveModelThunk");
var styles = require("../../styles/LayoutStyles");
var LayoutStyles_1 = require("../../styles/LayoutStyles");
var TestIds_1 = require("../../util/TestIds");
var PrometheusEditorHeader_1 = require("../PrometheusEditorHeader");
var Index_1 = require("../base/Index");
var SelectNameAndProjectDialog_1 = require("./deploy-dialog/SelectNameAndProjectDialog");
var DeployModelCardSection = function (props) {
    var _a = React.useState(false), dialogVisible = _a[0], setDialogVisible = _a[1];
    // TODO For alpha show a spinner while deploying. For MVP we should keep the dialog showing and put the spinner in the button.
    var _b = React.useState(false), deploying = _b[0], setDeploying = _b[1];
    var model = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModel);
    var deployedVersion = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectDeployedVersion).deployedVersion;
    var modelSucceededTraining = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelSucceededTraining);
    var trainingJob = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectJob);
    var latestDeployment = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectLatestDeployment).latestDeployment;
    var dispatch = (0, react_redux_1.useDispatch)();
    var thunkDispatch = (0, RootReducer_1.useAppThunkDispatch)();
    var handleOnCredentialsAdded = function (credentialId, _credentialProperties) {
        callDeployModel();
    };
    var _c = React.useState(''), predictionDefinitionName = _c[0], setPredictionDefinitionName = _c[1];
    React.useEffect(function () {
        if (latestDeployment) {
            (0, TagHelpers_1.GetPredictDefName)({ predictionDefinitionId: latestDeployment.einsteinPredictionDefinitionId }).then(function (response) {
                var _a;
                setPredictionDefinitionName((_a = response.predictionDefinitionName) !== null && _a !== void 0 ? _a : '');
            }, function (reason) {
                console.log(reason);
            });
        }
    }, [latestDeployment]);
    var callDeployModel = function () {
        (0, TagHelpers_1.GetSalesForceAuthenticationStatus)({}).then(function (response) {
            if (!response.isAuthenticated) {
                (0, PrometheusEditorHeader_1.doOAuthSignIn)(props.server, handleOnCredentialsAdded);
            }
            else {
                deployModel();
            }
        }, function (reason) {
            console.log(reason);
        });
    };
    var deployModel = function () {
        setDeploying(true);
        (0, TagHelpers_1.DeployModel)({
            storyId: trainingJob.einsteinStoryId,
            runId: trainingJob.einsteinRunId,
        })
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isEinsteinDeploymentSuccessful(response)) return [3 /*break*/, 3];
                        return [4 /*yield*/, recordSuccessfulDeployment(response.deployedModelId, response.predictionDefinitionId)];
                    case 1:
                        _a.sent();
                        // editModel() is required to get updated model.containerName information after moving the model
                        return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.editModel)({ luid: model.luid }))];
                    case 2:
                        // editModel() is required to get updated model.containerName information after moving the model
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); }, function (reason) {
            console.log(reason);
        })
            .finally(function () {
            getDeploymentRecords().catch(function (err) { return console.log('Could not retrieve deployment records'); });
            setDeploying(false);
        });
    };
    var isEinsteinDeploymentSuccessful = function (response) {
        return !!(response.deployedModelId && response.predictionDefinitionId);
    };
    var recordSuccessfulDeployment = function (einsteinDeployedModelId, einsteinPredictionDefinitionId) {
        var recordDeploymentParams = {
            einsteinDeployedModelId: einsteinDeployedModelId,
            einsteinPredictionDefinitionId: einsteinPredictionDefinitionId,
        };
        return thunkDispatch((0, PredictiveModelThunk_1.recordDeployment)(recordDeploymentParams));
    };
    // This sequence of api calls is temporary. Post-alpha, the deployment information will be returned from the server in one call
    var getDeploymentRecords = function () { return __awaiter(void 0, void 0, void 0, function () {
        var deployedVersionResult, latestDeploymentParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!model) return [3 /*break*/, 2];
                    return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.getDeployedVersion)()).unwrap()];
                case 1:
                    deployedVersionResult = _a.sent();
                    if (deployedVersionResult) {
                        latestDeploymentParams = { versionLuid: deployedVersionResult.luid };
                        return [2 /*return*/, thunkDispatch((0, PredictiveModelThunk_1.getLatestDeploymentByVersionLuid)(latestDeploymentParams))];
                    }
                    return [2 /*return*/, Promise.reject()];
                case 2: return [2 /*return*/, Promise.reject()];
            }
        });
    }); };
    var getModelDeploymentStatusText = function () {
        if (latestDeployment) {
            return Localize_1.Messages.deployModelSubtitleModelDeployed({ date: new Date(latestDeployment.deployedAt).toLocaleString() });
        }
        return Localize_1.Messages.deployModelSubtitleNoModelDeployed();
    };
    var getModelDeploymentDescriptionText = function () {
        if (deployedVersion && latestDeployment) {
            var objectiveField = deployedVersion.objectiveSuccessValue
                ? Localize_1.Messages.valueAsExpression({
                    value: deployedVersion.objectiveTargetField,
                    as: deployedVersion.objectiveSuccessValue,
                })
                : deployedVersion.objectiveTargetField;
            var goal = "".concat(deployedVersion.objectiveGoal, " ").concat(objectiveField);
            return (React.createElement("div", null,
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionModelName({ modelName: model.name })),
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionVersion({ version: deployedVersion.versionNumber })),
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionGoal({ modelGoal: goal })),
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionAlgorithm({ modelAlgorithm: deployedVersion.objectiveAlgorithm })),
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionDeployedBy({ user: latestDeployment.deployer.displayName })),
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionEinsteinDmId({ einsteinDeployedModelId: latestDeployment.einsteinDeployedModelId })),
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionEinsteinPdId({
                    einsteinPredictionDefinitionId: latestDeployment.einsteinPredictionDefinitionId,
                })),
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionEinsteinPdName({
                    einsteinPredictionDefinitionName: predictionDefinitionName,
                })),
                React.createElement("p", null, Localize_1.Messages.deployModelDescriptionLocation({ containerName: model.containerName }))));
        }
        return (React.createElement("div", null,
            React.createElement("p", null, Localize_1.Messages.deployModelDescriptionNoModelDeployed())));
    };
    var showDeployModelDialog = function () {
        setDialogVisible(true);
    };
    var hideDeployModelDialog = function () {
        setDialogVisible(false);
    };
    var onDialogConfirm = function (projectId, name) {
        var setNameparams = { name: name };
        var moveParams = { containerId: projectId };
        dispatch((0, PredictiveModelThunk_1.setModelName)(setNameparams));
        dispatch((0, PredictiveModelThunk_1.moveModel)(moveParams));
        callDeployModel();
        hideDeployModelDialog();
    };
    var renderDeployModelCard = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.predictiveModelEditorDeployModelCentered },
                React.createElement("h1", { className: styles.predictiveModelEditorDeployModelSubspaceTitle }, Localize_1.Messages.deployModelSubspaceTitle())),
            React.createElement("div", { className: styles.predictiveModelEditorDeployModelCentered },
                React.createElement("div", { className: styles.predictiveModelEditorDeployModelCard },
                    !deploying && (React.createElement("div", { className: styles.predictiveModelEditorDeployModelCardContent },
                        React.createElement("h3", null, getModelDeploymentStatusText()),
                        getModelDeploymentDescriptionText(),
                        React.createElement("div", { className: styles.predictiveModelEditorDeployButton },
                            React.createElement("div", null,
                                React.createElement(widgets_1.ButtonWidget, { onClick: showDeployModelDialog, testId: TestIds_1.DEPLOY_BUTTON_TEST_ID, buttonType: widgets_1.ButtonType.Primary, disabled: !modelSucceededTraining ||
                                        (latestDeployment !== undefined &&
                                            deployedVersion !== undefined &&
                                            deployedVersion.luid === model.activeVersion.luid) }, Localize_1.Messages.deployModelButton())),
                            React.createElement("div", null,
                                React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.LowEmphasis, onClick: function () { return (0, PrometheusEditorHeader_1.signoutAndLaunchSalesforceLoginDialog)(props.server, function () { return void 0; }); }, testId: TestIds_1.CHANGE_CREDENTIAL_BUTTON_TEST_ID, className: LayoutStyles_1.changeSalesforceCredsTextStyle, hidden: false }, Localize_1.Messages.changeCredentialButton()))))),
                    deploying && React.createElement(Index_1.Loader, null)))));
    };
    var renderDeployModelDialog = function () {
        var dialogProps = {
            initialPredictiveModelName: model.name,
            siteName: 'temporaryString',
            onCloseRequest: hideDeployModelDialog,
            onConfirmRequest: onDialogConfirm,
        };
        return React.createElement(SelectNameAndProjectDialog_1.SelectNameAndProjectDialog, __assign({}, dialogProps));
    };
    var renderDeployModelSection = function () {
        return (React.createElement(React.Fragment, null,
            dialogVisible && renderDeployModelDialog(),
            renderDeployModelCard()));
    };
    return renderDeployModelSection();
};
exports.default = DeployModelCardSection;
//# sourceMappingURL=DeployModelCardSection.js.map